import { useMatch } from "react-router-dom";

const PATH_PREFIX = "/org/:orgId/ws/:wsId";

export const useCurrentPage = () => {
  const isEntityViewPage = Boolean(
    useMatch(`${PATH_PREFIX}/entities/:schema/:id/*`),
  );
  const isFeaturesPage = Boolean(useMatch(`${PATH_PREFIX}/features/*`));
  const isEventsPage = Boolean(useMatch(`${PATH_PREFIX}/events/*`));
  const isSettingsPage = Boolean(useMatch(`${PATH_PREFIX}/settings/*`));
  const isFlowPage = Boolean(useMatch(`${PATH_PREFIX}/flows/:flowId/*`));
  const isAuthoringPage = Boolean(useMatch(`${PATH_PREFIX}/flow/*`));
  const isEntitiesPage = Boolean(useMatch(`${PATH_PREFIX}/entities/:schema`));
  const casesQueueMatch = useMatch({
    path: `${PATH_PREFIX}/cases/queues/:queue_id`,
    end: true,
  });
  const isCasesQueuePage =
    casesQueueMatch != null && casesQueueMatch.params.queue_id !== "new";
  const isCasesSection = Boolean(useMatch(`${PATH_PREFIX}/cases/*`));
  const isAgentsPage = Boolean(
    useMatch({ path: `${PATH_PREFIX}/agents`, end: true }),
  );
  const isAgentDetailPage = Boolean(
    useMatch(`${PATH_PREFIX}/agents/:agentId/*`),
  );
  const isFlowsListPage = Boolean(
    useMatch({ path: `${PATH_PREFIX}/flows`, end: true }),
  );
  const isFlowAnalyticsPage = Boolean(
    useMatch(`${PATH_PREFIX}/flows/:flowId/analytics`),
  );
  const isCaseAnalyticsPage = Boolean(
    useMatch(`${PATH_PREFIX}/cases/analytics`),
  );
  const isWorkspaceInsightsPage = Boolean(useMatch(`${PATH_PREFIX}/insights`));

  return {
    isEntityViewPage,
    isFeaturesPage,
    isEventsPage,
    isSettingsPage,
    isFlowPage,
    isAuthoringPage,
    isEntitiesPage,
    isAgentsPage,
    isAgentDetailPage,
    isFlowsListPage,
    isFlowAnalyticsPage,
    isCasesQueuePage,
    isCaseAnalyticsPage,
    isCasesSection,
    isWorkspaceInsightsPage,
  };
};
